/**
 * Structured-logging contract shared by browser and server code. The call
 * shape mirrors pino's `(fields, message)` so the SSR runtime can hand its
 * pino logger straight to code in this workspace, while browser bundles keep
 * the console implementation and never pull pino in.
 */
export type LogFields = Record<string, unknown>;

export interface Logger {
	debug(fields: LogFields, message: string): void;
	info(fields: LogFields, message: string): void;
	warn(fields: LogFields, message: string): void;
	error(fields: LogFields, message: string): void;
}

export const consoleLogger: Logger = {
	debug: (fields, message) => console.debug(message, fields),
	info: (fields, message) => console.info(message, fields),
	warn: (fields, message) => console.warn(message, fields),
	error: (fields, message) => console.error(message, fields),
};
